
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationManagerResource,
  UpdateManagerRequest,
} from '../models';
import {
    OrganizationManagerResourceFromJSON,
    OrganizationManagerResourceToJSON,
    UpdateManagerRequestFromJSON,
    UpdateManagerRequestToJSON,
} from '../models';

export interface UpdateManagerOperationRequest {
    organizationId: string;
    updateManagerRequest: UpdateManagerRequest;
}

/**
 * 
 */
export class OrganizationManagerAdminApi extends runtime.BaseAPI {

    /**
     * Retrieve every malt managers
          */
    async getAllManagersRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<OrganizationManagerResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<OrganizationManagerResource>>({
            path: `/client-settings/api/organizations/managers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(OrganizationManagerResourceFromJSON);
        return response;
    }

    /**
     * Retrieve every malt managers
          */
    async getAllManagers(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<OrganizationManagerResource>> {
        const response = await this.getAllManagersRaw(initOverrides);
        return response._data;
    }

    /**
     * Update one kind of manager for the given organization
          */
    async updateManagerRaw(requestParameters: UpdateManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateManager().'
            );
        }

        if (requestParameters['updateManagerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateManagerRequest',
                'Required parameter "updateManagerRequest" was null or undefined when calling updateManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/managers`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateManagerRequestToJSON(requestParameters['updateManagerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update one kind of manager for the given organization
          */
    async updateManager(requestParameters: UpdateManagerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateManagerRaw(requestParameters, initOverrides);
    }

}
